import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgWarning(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#F27500" />
      <path
        fill="white"
        fillRule="evenodd"
        d="M13.7 6.5H18.2999L17.5999 16.5H14.3999L13.7 6.5ZM13.36 22.14C13.36 20.682 14.542 19.5 16 19.5C17.458 19.5 18.64 20.682 18.64 22.14C18.64 23.598 17.458 24.78 16 24.78C14.542 24.78 13.36 23.598 13.36 22.14Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgWarning);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
